import { render } from "./ToDoDetails.vue?vue&type=template&id=1c33e1a3&ts=true"
import script from "./ToDoDetails.vue?vue&type=script&lang=ts"
export * from "./ToDoDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__